import {useEffect, useState} from 'react';

export const useNavBarDropdown = (ref) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const node = ref.current;
        let timeout = null;

        const handleEnter = () => {
            timeout = setTimeout(() => setOpen(true), 75);
        }

        const handleLeave = () => {
            clearTimeout(timeout);
            setOpen(false);
        }

        node.addEventListener("mouseenter", handleEnter);
        node.addEventListener("mouseleave", handleLeave);

        return () => {
            node.removeEventListener("mouseenter", handleEnter);
            node.removeEventListener("mouseleave", handleLeave);
        };
    }, [ref])

    return { open, setOpen };
}